module.exports = __webpack_public_path__ + "static/img/female-bg-ar.bc21ec1f.png";